<template>
	<div>
		<div v-if="sortingData.boxTitles">
			<span style="font-size: 16px;">周转物:</span>
			<a style="font-size: 16px;" @click="querySortingTurnoverBoxList">{{sortingData.boxTitles}}</a>
		</div>
		<Modal v-model="isShow" footer-hide :width="750">
			<div slot="header"><b>周转物清点</b></div>
			<div style="padding: 20px;">
				<Form label-position="left">
					<FormItem v-for="(item,index) of turnoverBoxList" :key="index">
						<div style="width: 180px;float: left;height: 50px;line-height: 40px;">
							<Badge :text="item.box_type==1?'押金筐':'周转框'">
								{{item.box_title}}
							</Badge>
						</div>
						<div style="width: 140px;float: left;height: 50px;line-height: 40px;">
							<span v-if="item.box_type==1">预借出数:{{item.box_count}}</span>
						</div>
						<div style="width: 258px;float: left;height: 50px;text-align: center;">
							借出:
							<InputNumber controls-outside size="large" :min="1" v-model="item.real_count"
							             :disabled="item.status>1"/>
							<a style="padding-left: 10px;color: #e13d13" v-if="item.status==1 || item.box_type==2" @click="deleteBox(index)">删除</a>
						</div>
					</FormItem>
				</Form>
			</div>
			<Button size="large" long icon="md-checkmark-circle" type="primary" @click="updateSortingTurnoverBox">完成清点</Button>
		</Modal>
	</div>
</template>

<script>
	// import {changeUnit} from "@/libs/util";
	import {querySortingTurnoverBoxList, updateSortingTurnoverBox} from "@/api/sorting/turnoverBox"

	export default {
		name: "sortingTurnbox",
		props: {
			// 分拣数据
			sortingData: {
				type: Object,
				default: {}
			},
		},
		data() {
			return {
				isShow: false,
				// 周转物列表
				turnoverBoxList: [],
				// 删除的id
				deleteIds: []
			};
		},
		methods: {
			// 查询关联称重框
			querySortingTurnoverBoxList() {
				this.isShow = true;
				this.deleteIds = [];
				querySortingTurnoverBoxList({
					rows: 100,
					inner_no: this.sortingData.inner_no,
					product_child_id: this.sortingData.product_child_id
				}).then(data => {
					if (data.data.code == 1200) {
						this.turnoverBoxList = data.data.data.rows;
					}
				});
			},
			// 删除周转物
			deleteBox(index) {
				this.deleteIds.push(this.turnoverBoxList[index].id);
				this.turnoverBoxList.splice(index, 1);
			},
			// 更新商品关联周转物
			updateSortingTurnoverBox() {
				updateSortingTurnoverBox({deleteIds: this.deleteIds, turnoverBoxList: this.turnoverBoxList}).then(data => {
					if (data.data.code == 1200) {
						let boxTitles = "";
						for (let i = 0; i < this.turnoverBoxList.length; i++) {
							boxTitles += this.turnoverBoxList[i].box_title + "*" + this.turnoverBoxList[i].real_count + " "
						}
						this.sortingData.boxTitles = boxTitles;
						this.isShow = false;
					} else {
						this.$Message.error(data.data.msg)
					}
				});
			}
		},
		mounted() {
		},
		destroyed() {
		},
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sortingTurnbox/sortingTurnbox.vue